import { loadDocuments } from "@/api/regulations";

const SET_DOCUMENTS = "SET_DOCUMENTS";
const SET_LOADING = "SET_LOADING";

const initialState = {
  documents: [],
  itemsPerPage: 8,
  totalCount: 0,
  loading: false
};

const getters = {
  documents: state => state.documents,
  totalCount: state => state.totalCount,
  loading: state => state.loading
};

const actions = {
  async fetchDocuments({ commit, state }) {
    try {
      commit(SET_LOADING, true);
      const response = await loadDocuments({
        offset: state.documents.length,
        limit: state.itemsPerPage
      });
      commit(SET_DOCUMENTS, response);
      commit(SET_LOADING, false);
    } catch (e) {
      throw e;
    }
  }
};

const mutations = {
  [SET_DOCUMENTS](state, { data, meta }) {
    state.documents = [...state.documents, ...data];
    state.totalCount = meta.pagination.total;
  },
  [SET_LOADING](state, data) {
    state.loading = data;
  }
};

export default {
  state: { ...initialState },
  getters,
  actions,
  mutations
};
